import PropTypes from "prop-types";

// @mui material components
import { CircularProgress, Divider, Grid, Skeleton } from "@mui/material";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";

function DevicesTableSkeleton({ deviceLayout, appearance, isKerbsides, canAssignmentsView, isMobileView }) {

    return (
        <SoftBox borderRadius="20px" color={"white"} width="100%"
            height={deviceLayout === 'mobile' ? 'calc(100svh - 4.25rem - 8px)' : "calc(100svh - 5.5rem - 16px)"}
            minHeight={deviceLayout === 'mobile' ? "calc(100svh - 4.25rem - 8px)" : undefined}
            sx={({ palette, functions: { rgba } }) => ({ backgroundColor: rgba(palette[appearance].background, 0.7), overflowY: 'hidden' })}
        >
            <SoftBox mt={1} display="flex" sx={{ height: `calc(100% - 16px)` }}>
                <SoftBox display="flex" flexDirection="column" borderRadius="10px" color={"white"} width="100%" height={"100%"}>
                    <SoftBox height="100%" sx={() => ({ borderRadius: '16px 16px 0 0' })}>
                        <SoftBox px={1} height="100%" display="flex" flexDirection="column">
                            {/* Top Cards Skeleton */}
                            <SoftBox mb={1}>
                                <Grid container spacing={1}>
                                    <Grid item xxs={12} md={isKerbsides && (canAssignmentsView && !isMobileView) ? 4 : (isKerbsides || (canAssignmentsView && !isMobileView) ? 6 : 12)}>
                                        <SoftBox px={2} display="flex" flexDirection="column" gap={1} justifyContent="center" sx={{ backgroundColor: '#eee', height: '76px', borderRadius: '16px' }}>
                                            <Skeleton variant="rectangular" width={120} sx={{ borderRadius: '8px' }} />
                                            <Skeleton variant="rectangular" width={60} sx={{ borderRadius: '8px' }} />
                                        </SoftBox>
                                    </Grid>
                                    {(canAssignmentsView && !isMobileView) && (
                                        <Grid item xxs={12} xl={isKerbsides ? 4 : 6}>
                                            <SoftBox px={2} display="flex" flexDirection="column" gap={1} justifyContent="center" sx={{ backgroundColor: '#eee', height: '76px', borderRadius: '16px' }}>
                                                <Skeleton variant="rectangular" width={120} sx={{ borderRadius: '8px' }} />
                                                <Skeleton variant="rectangular" width={60} sx={{ borderRadius: '8px' }} />
                                            </SoftBox>
                                        </Grid>
                                    )}
                                    {isKerbsides && (
                                        <Grid item xxs={12} md={canAssignmentsView && !isMobileView ? 4 : 6}>
                                            <SoftBox px={2} display="flex" flexDirection="column" gap={1} justifyContent="center" sx={{ backgroundColor: '#eee', height: '76px', borderRadius: '16px' }}>
                                                <Skeleton variant="rectangular" width={120} sx={{ borderRadius: '8px' }} />
                                                <Skeleton variant="rectangular" width={60} sx={{ borderRadius: '8px' }} />
                                            </SoftBox>
                                        </Grid>
                                    )}
                                </Grid>
                            </SoftBox>

                            {/* Table Skeleton */}
                            <SoftBox display="flex" flexDirection="column" height="100%" flex={1} minHeight={0}>
                                <SoftBox sx={{ overflowY: 'hidden', backgroundColor: appearance === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#eee', borderRadius: '16px', height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    {/* Mock Search/Toolbar */}
                                    <SoftBox display="flex" p={2} gap={2} justifyContent="space-between" sx={{ backgroundColor: '#dcdcdc', borderRadius: '16px 16px 0 0' }}>
                                        <Skeleton variant="rectangular" width={'40%'} height={48} sx={{ borderRadius: '8px' }} />
                                        <Skeleton variant="rectangular" width={'60%'} height={48} sx={{ borderRadius: '8px' }} />
                                    </SoftBox>
                                    <Divider />
                                    <SoftBox m={2} sx={{ borderRadius: '12px', height: '100%', backgroundColor: '#fefefe' }}>
                                        {/* Mock Table Header */}
                                        <SoftBox p={2} sx={{ height: '100%', borderRadius: '12px' }}>
                                            <Skeleton variant="rectangular" width="100%" height={30} sx={{ borderRadius: '4px', mb: 2 }} />
                                            {/* Mock Table Rows */}
                                            <SoftBox
                                                display="flex"
                                                flexDirection="column"
                                                justifyContent="center"
                                                alignItems="center"
                                                minHeight="calc(100% - 72px)"
                                            >
                                                <CircularProgress color="dark" />
                                                <SoftTypography variant="button" fontWeight="medium" mt={2} color="dark">
                                                    Loading...
                                                </SoftTypography>
                                            </SoftBox>
                                        </SoftBox>
                                    </SoftBox>
                                </SoftBox>
                            </SoftBox>
                        </SoftBox>
                    </SoftBox>
                </SoftBox>
            </SoftBox>
        </SoftBox>
    );
}

DevicesTableSkeleton.propTypes = {
    deviceLayout: PropTypes.string,
    appearance: PropTypes.string,
    isKerbsides: PropTypes.bool,
    canAssignmentsView: PropTypes.bool,
    isMobileView: PropTypes.bool
};

export default DevicesTableSkeleton;